import { createContext } from 'react';

import { SlotsStateAPI } from '../../types/slotsStateAPI';

const SlotsAPIContext = createContext<SlotsStateAPI>({} as SlotsStateAPI);
SlotsAPIContext.displayName = 'SlotsAPIContext';

export { SlotsAPIContext };
